import script from "./HelpService.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpService.vue?vue&type=script&setup=true&lang=ts"

import "./HelpService.vue?vue&type=style&index=0&id=17a02b9e&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a02b9e"]])

export default __exports__